import * as React from 'react';
import { Dimensions } from '@bubble-ui/util-dimensions';
import { BREAKPOINTS } from './config';
import { useBreakpoint } from './useBreakpoint';
var getDeviceBreakpoints = () => {
  var {
    width
  } = Dimensions;
  return Object.fromEntries(Object.entries(BREAKPOINTS).map(_ref => {
    var [key, breakpoint] = _ref;
    return [key, width >= breakpoint];
  }));
};
var getActiveBreakpoints = activeBreakpoint => {
  var hasReachedBreakpoint = false;
  return Object.fromEntries(Object.keys(BREAKPOINTS).map(key => {
    if (hasReachedBreakpoint) {
      return [key, false];
    }
    if (key === activeBreakpoint) {
      hasReachedBreakpoint = true;
    }
    return [key, true];
  }));
};
export var ResponsiveContext = /*#__PURE__*/React.createContext(getDeviceBreakpoints());
var ResponsiveProvider = _ref2 => {
  var {
    children,
    forceActiveBreakpoint
  } = _ref2;
  var activeBreakpointFromHook = useBreakpoint();
  var activeBreakpoint = forceActiveBreakpoint || activeBreakpointFromHook;
  return /*#__PURE__*/React.createElement(ResponsiveContext.Provider, {
    value: activeBreakpoint ? getActiveBreakpoints(activeBreakpoint) : getDeviceBreakpoints()
  }, children);
};
ResponsiveProvider.displayName = 'ResponsiveProvider';
var getCurrentBreakpoint = activeBreakpoints => {
  var current = Object.entries(activeBreakpoints).reduce((acc, _ref3) => {
    var [key, value] = _ref3;
    if (value) {
      return key;
    }
    return acc;
  }, 'base');
  return current;
};
var useBreakpoints = () => React.useContext(ResponsiveContext);
export { BREAKPOINTS, getCurrentBreakpoint, useBreakpoints, ResponsiveProvider };
//# sourceMappingURL=index.js.map